<template>
  <section class="svg-icon-component">
    <svg
      class="app-svg-icon"
      :height="size"
      :width="size"
      :fill="fill"
      aria-hidden="true">
      <use :xlink:href="symbolId" />
    </svg>
  </section>
</template>

<script setup>
import { computed } from 'vue';

// 需要多空一行避免inherit-attrs=false失效 vue bug
const prefix = 'icon';
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 24,
  },
  fill: {
    type: String,
    default: '#cccccc',
  },
});

const symbolId = computed(() => `#${prefix}-${props.name}`);
</script>
